function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 4h5m0 0v5m0-5l-9.333 9.6M12 5.28H4V20h14.667v-8.32",
  stroke: "#8781bd",
  strokeWidth: 2
});

function SvgRedirect24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTUgNGg1bTAgMHY1bTAtNS05LjMzMzMgOS42bTEuMzMzMy04LjMyaC04djE0LjcyaDE0LjY2Njd2LTguMzIiIHN0cm9rZT0iIzg3ODFiZCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+";
export { SvgRedirect24Px as ReactComponent };